import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import StickyNavbar from './components/navigation/NavBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider, useAuth } from './utils/context/AuthContext';
import Login from './components/auth/login';
import Register from './components/auth/register';
import HomaPage from './pages/HomePage/HomePage';
import Profile from './pages/ProfilePage/profile';
import PricaPolicy from './components/PrivacyPolicy';
import Footer from './components/navigation/Footer';
const MainLayout = () => {
  return (
    <div className="bg-lightGray w-full h-screen overflow-auto flex flex-col flex-grow">
      <StickyNavbar />
      <div className="flex-grow justify-center items-center flex  md:w-2/3 mx-auto">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};
const PrivateRoute = () => {
  const { isLoggedIn } = useAuth();
  return isLoggedIn ? <Outlet /> : <Navigate to="/login" />;
};

const IsLoggedInRedirect = () => {
  const { isLoggedIn } = useAuth();
  return !isLoggedIn ? <Outlet /> : <Navigate to="/" />;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <AuthProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomaPage />} />
          <Route path="privacy-policy" element={<PricaPolicy />} />
          <Route element={<PrivateRoute />}>
            <Route path="profile" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
          <Route element={<IsLoggedInRedirect />}>
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);
